import * as Yup from 'yup';

import { FULL_NAME_REGEX } from '@utils/constants';
import validateSubscriptionEmail from '@utils/validateSubscriptionEmail';

const validationSchema = () =>
  Yup.object().shape({
    email: validateSubscriptionEmail(),
    name: Yup.string()
      .matches(FULL_NAME_REGEX, 'Please enter a first and last name')
      .required('Full name is required'),
  });

export default validationSchema;
